import {lazy} from "react";

export const ReportVoyagePointDataLazy = lazy(()=>import('./ReportVoyagePointData'))